import { handleActions } from 'redux-actions';
import { DamzState } from '../../types';
import { setDrawerFilter } from '../actions/drawer';

export default handleActions<DamzState['drawer'], any>(
  {
    [`${setDrawerFilter}`]: (state, action: ReturnType<typeof setDrawerFilter>) => ({
      ...state,
      activeFilter: action.payload.filter,
    }),
  },
  {
    activeFilter: 'all',
  }
);
